import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'https://ijlzhwgjjyugthyzdbuq.supabase.co';
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImlqbHpod2dqanl1Z3RoeXpkYnVxIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTk3ODI0MDksImV4cCI6MjA3NTM1ODQwOX0.1yjtlp3f09H1rKWrKToH48Q04wOZ4tiS7iknanuVvfg';

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  db: {
    schema: 'public',
  },
  global: {
    headers: {
      'Cache-Control': 'no-cache, no-store, must-revalidate',
      'Pragma': 'no-cache',
      'Expires': '0',
    },
  },
});

export type Database = {
  public: {
    Tables: {
      brands: {
        Row: {
          id: string;
          name: string;
          logo_url: string | null;
          primary_color: string;
          secondary_color: string;
          contact_info: any;
          terms_text: string;
          created_at: string;
          updated_at: string;
        };
      };
      users: {
        Row: {
          id: string;
          email: string;
          full_name: string;
          role: 'admin' | 'manager' | 'sales_rep';
          created_at: string;
          updated_at: string;
        };
      };
      service_pricing: {
        Row: {
          id: string;
          brand_id: string;
          category: string;
          client_type: string | null;
          tier_key: string;
          name: string;
          price: number;
          additional_price: number | null;
          created_at: string;
          updated_at: string;
        };
      };
      additional_pricing: {
        Row: {
          id: string;
          brand_id: string;
          item_key: string;
          name: string;
          price: number;
          created_at: string;
          updated_at: string;
        };
      };
      support_plans: {
        Row: {
          id: string;
          brand_id: string;
          tier_key: string;
          name: string;
          hours: number;
          price: number;
          created_at: string;
          updated_at: string;
        };
      };
      discount_codes: {
        Row: {
          id: string;
          brand_id: string;
          code: string;
          type: 'percentage' | 'fixed' | 'conditional';
          value: number | null;
          base_value: number | null;
          bonus_value: number | null;
          applicable_to: 'website' | 'marketing' | 'both';
          waive_setup: boolean;
          condition: string | null;
          active: boolean;
          created_at: string;
          updated_at: string;
        };
      };
      estimates: {
        Row: {
          id: string;
          brand_id: string;
          user_id: string;
          client_name: string;
          client_type: 'local' | 'ecommerce' | 'b2b';
          status: 'draft' | 'sent' | 'accepted' | 'declined';
          config: any;
          totals: any;
          created_at: string;
          updated_at: string;
        };
      };
    };
  };
};
